/* eslint-disable */
const APP = require('../config');

export class ApiError extends Error {}
export class BaseService {
  apiUrl = APP.apiUrl;
}
